import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GLOBAL_IMAGES } from "../../../assets/asset";
import { getClassBookingBasePath } from "../../../features/parentFlow/parentFlow";
import { logout } from "../../../features/auth/user.reducer";

const Header = ({ heading, subheading, name, subject, backLabel }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useSelector((state) => state.user);
  const basePath = getClassBookingBasePath(location.pathname);
  const isParentFlow = basePath.startsWith("/parent/");
  
  const hasProps = heading || subheading || name || subject;
  
  const handleMyBookings = () => {
    navigate(`${basePath}/myBookings`);
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/tutorinfo", { replace: true });
  };

  return (
    <header
      className={`w-full px-8 py-4 fixed top-0 left-0 z-50 ${
        isParentFlow ? "bg-[#f8f3ea]/95 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="w-full flex items-center justify-between">
        <button
          type="button"
          className="flex items-center gap-3"
          onClick={() => navigate(-1)}
        >
          <img
            src={GLOBAL_IMAGES.LoginBackButton}
            className="w-14 h-14 cursor-pointer"
            alt="back"
          />
          {backLabel && (
            <span
              className={`text-lg font-medium ${
                isParentFlow ? "text-[#0B2B66] font-bold" : "text-gray-900"
              }`}
            >
              {backLabel}
            </span>
          )}
        </button>

        {hasProps && (
          <div className="text-center">
            <h1
              className={`text-3xl font-bold font-mali ${
                isParentFlow ? "text-[#0B2B66]" : ""
              }`}
            >
              {heading || "Welcome"}
              {name ? `, ${name}!` : "!"}
            </h1>
            <p
              className={`text-lg -mt-1 font-mali ${
                isParentFlow ? "text-[#475569]" : ""
              }`}
            >
              {subheading || "Let's help you excel"}
              {subject ? ` in ${subject}` : ""} today
            </p>
          </div>
        )}

        <div className="flex items-center gap-3">
          {hasProps && (
            <button
              onClick={handleMyBookings}
              className={`px-6 py-3 rounded-full shadow-md font-semibold ${
                isParentFlow
                  ? "bg-[#08059B] text-white"
                  : "bg-white text-gray-900"
              }`}
            >
              My Bookings
            </button>
          )}
          {isParentFlow && token ? (
            <button
              type="button"
              onClick={handleLogout}
              className="rounded-full border border-[#d8cfbf] bg-white px-6 py-3 text-sm font-bold text-[#0B2B66] shadow-md transition hover:border-[#08059B] hover:text-[#08059B] sm:text-base"
            >
              Logout
            </button>
          ) : null}
        </div>
      </div>
    </header>
  );
};

export default Header;
